import { ReactComponent as Happy } from '../../../assets/early/svg/emotions/Happy.svg'
import { ReactComponent as Excited } from '../../../assets/early/svg/emotions/Excited.svg'
import { ReactComponent as Ok } from '../../../assets/early/svg/emotions/Ok.svg'
import { ReactComponent as Sad } from '../../../assets/early/svg/emotions/Sad.svg'
import { ReactComponent as Afraid } from '../../../assets/early/svg/emotions/Afraid.svg'
import { ReactComponent as Angry } from '../../../assets/early/svg/emotions/Angry.svg'

export const emotions_heads = {
    happy: <Happy width={40} height={40} />,
    excited: <Excited width={40} height={40} />,
    ok: <Ok width={40} height={40} />,
    sad: <Sad width={40} height={40} />,
    afraid: <Afraid width={40} height={40} />,
    angry: <Angry width={40} height={40} />,
}

export const emotions_heads_width_30 = {
    happy: <Happy width={30} height={30} />,
    excited: <Excited width={30} height={30} />,
    ok: <Ok width={30} height={30} />,
    sad: <Sad width={30} height={30} />,
    afraid: <Afraid width={30} height={30} />,
    angry: <Angry width={30} height={30} />,
}

export const emotions_list = ['happy', 'excited', 'ok', 'sad', 'afraid', 'angry']
export const backgroundColors = ['#FDDF6D', '#ED68A0', '#83CDF5', '#4F6288', '#BC8ABD', '#FC4C59']

export const MODAL_ANIMATION_TIME = 600
export const BACKDROP_OPACITY = 0.4

export const emotions_color = {
    happy: '#FDDF6D',
    calm: '#83CDF5',
    ecstatic: '#F47C39',
    grumpy: '#6FCC87',
    angry: '#FC4C59',
    sad: '#4F6288',
    stressed: '#DC8CDD',
    lethargic: '#C1A7ED',
    inspired: '#ED68A0',
    false: ' rgba(31, 31, 67, 0.05)',
    good: '#BAEF90',
    worried: '#E4A6B1',
    numb: '#399AF4',
    ok: '#83CDF5',
    afraid: '#BC8ABD',
    excited: '#ED68A0',
}

export const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

export const bar_chart_emotions_list = ['happy', 'excited', 'ok', 'sad', 'afraid', 'angry']
export const FAKE_STUDENTS = [{ first_name: 'Petar', last_name: 'Obradovic', emotion: 'happy', animal: 'tiger', id: 1 }]

export const EMOTION_ANIMAL_BACKGROUND_COLOR = {
    happy: '#E7C544',
    excited: '#ED68A0',
    ok: '#83CDF5',
    afraid: '#BC8ABD',
    sad: '#4F6288',
    angry: '#FC4C59',
    false: ' rgba(31, 31, 67, 0.05)',
}
export const EMOTION_BACKGROUND_COLOR = {
    happy: '#FDDF6D',
    excited: '#ED68A0',
    ok: '#83CDF5',
    afraid: '#BC8ABD',
    sad: '#4F6288',
    angry: '#FC4C59',
    false: ' rgba(31, 31, 67, 0.05)',
}

export const SECURITY_MODAL_TITLE = {
    back: 'Enter your security key to switch from the child view to the teacher view',
    settings: 'Enter your security key to access settings',
    reset: 'Enter your security key to reset your answers',
}

export const ANIMALS_ARRAY = [
    'fox',
    'panda',
    'tiger',
    'raccoon',
    'shark',
    'hamster',
    'penguin',
    'bear',
    // 'octopus',
    'dog',
    'bird',
    'koala',
    'giraffe',
    'otter',
    'deer',
    'bunny',
    'elephant',
    'zebra',
    'sugarGlider',
    'leopard',
    'fish',
    'darkBear',
    'kitty',
    'beaver',
    'frog',
    'hedgeHog',
    'lion',
    'lama',
    'owl',
    'rabbit',
]

export const LANDSCAPE = 1
export const PORTRAIT = 2

export const lightShadowStyle = {
    shadowColor: '#000000',
    shadowOffset: {
        width: 0,
        height: 9,
    },
    shadowOpacity: 0.04,
    shadowRadius: 10,
    elevation: 10,
}
